const availableFonts = {
    defaultFont: 'Cabin',

    getAvailableFonts() {
        return ['AlfaSlabOne', 'Anton', 'Arial', 'ArchitectsDaughter', 'Bangers', 'BungeeShade', 'Cabin', 'CabinMedium', 'CaveatBrush', 'Creepster', 'Pangolin', 'Peralta', 'PermanentMarker', 'Raleway', 'RalewayBlack', 'RalewayThin', 'Shrikhand', 'Sniglet', 'SnigletExtra', 'Sriracha'];
    }
};

export default availableFonts;



/** WEBPACK FOOTER **
 ** ./src/constants/AvailableFonts.js
 **/